import type { SettingsSource } from '../models/settings-hub.model';

import { action, field } from './settings-builders';
import {
    countryOptions,
    currencyOptions,
    dayStartTimeOptions,
    timezoneOptions,
    uiLanguageOptions
} from './settings-options';

export const GENERAL_SUBCATEGORY: SettingsSource = {
    id: 'general',
    cards: [
        {
            id: 'business-data',
            settings: [
                field.text('general.shopname', 'SETTINGS.SETTINGS.PAYMENT_NAME', { readonly: context => context.isDemoShop }),
                field.text('general.company_name', 'SETTINGS.SETTINGS.COMPANY_NAME', { readonly: true }),
                field.text('general.vat_code', 'SETTINGS.SETTINGS.VAT_CODE', { readonly: true }),
                action('open-printer-logo-editor', 'SETTINGS.SETTINGS.SETUP_PRINTER_LOGO', { icon: 'image' })
            ]
        },
        {
            id: 'address',
            settings: [
                field.text('general.address_street', 'SETTINGS.SETTINGS.ADDRESS_FULL', { readonly: true }),
                field.text('general.address_zip', 'SETTINGS.SETTINGS.ADDRESS_ZIP', { readonly: true }),
                field.text('general.address_city', 'SETTINGS.SETTINGS.ADDRESS_CITY', { readonly: true }),
                field.text('general.address_prov', 'SETTINGS.SETTINGS.ADDRESS_COUNTY', { readonly: true }),
                field.select('general.address_country', 'SETTINGS.SETTINGS.ADDRESS_COUNTRY', { options: countryOptions, readonly: true })
            ]
        },
        {
            id: 'date-time',
            settings: [
                field.select('day_start_time_24', 'SETTINGS.SETTINGS.DAY_START_TIME', { options: dayStartTimeOptions }),
                field.select('general.timezone', 'SETTINGS.SETTINGS.TIME_ZONE', { options: timezoneOptions, keywords: ['timezone', 'fuso orario'] })
            ]
        },
        {
            id: 'regional',
            settings: [
                field.select('general.ui_language', 'SETTINGS.SETTINGS.UI_LANGUAGE', { options: uiLanguageOptions }),
                field.select('general.currency', 'SETTINGS.SETTINGS.CURRENCY', { options: currencyOptions })
            ]
        },
        {
            id: 'main-contacts',
            settings: [
                field.email('general.email', 'SETTINGS.SETTINGS.EMAIL'),
                field.email('general.bcc_copy', 'SETTINGS.SETTINGS.BCC_COPY_EMAIL'),
                field.text('general.phone', 'SETTINGS.SETTINGS.PHONE')
            ]
        },
        {
            id: 'social',
            settings: [
                field.text('general.whatsapp', 'SETTINGS.SETTINGS.WHATSAPP'),
                field.text('general.telegram', 'SETTINGS.SETTINGS.TELEGRAM'),
                field.text('general.messenger', 'SETTINGS.SETTINGS.MESSENGER'),
                field.text('general.wechat', 'SETTINGS.SETTINGS.WECHAT'),
                field.text('general.snapchat', 'SETTINGS.SETTINGS.SNAPCHAT'),
                field.text('general.tiktok', 'SETTINGS.SETTINGS.TIKTOK'),
                field.text('general.instagram', 'SETTINGS.SETTINGS.INSTAGRAM'),
                field.text('general.facebook', 'SETTINGS.SETTINGS.FACEBOOK'),
                field.text('general.twitter', 'SETTINGS.SETTINGS.TWITTER', { keywords: ['x'] })
            ]
        },
        {
            id: 'online-presence',
            settings: [
                field.text('general.website', 'SETTINGS.SETTINGS.WEBSITE'),
                field.text('general.map', 'SETTINGS.SETTINGS.MAP')
            ]
        }
    ]
};
